import CardDefault from "components/Cards/CardDefault/index";
import { Text, Flex, Box } from "@chakra-ui/react";
import { Progress } from "@chakra-ui/react";

interface BoletosEmRegistroProps {
  numeroBoletos: number | undefined;
}

export default function BoletosEmRegistro({
  numeroBoletos,
}: BoletosEmRegistroProps) {
  if (!numeroBoletos) {
    return null;
  }

  return (
    <Box mb={4}>
      <CardDefault padding={4} gap={2}>
        <Text fontSize="16px">Boletos em registro</Text>
        <Flex gap={4}>
          <Text fontSize="16px">{numeroBoletos}</Text>

          <Progress
            hasStripe
            isIndeterminate
            value={50}
            w="100%"
            mt="1"
            colorScheme="green"
            size="md"
            rounded={10}
          />
        </Flex>
      </CardDefault>
    </Box>
  );
}
